import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
// import VueClipboard from "vue-clipboard2";
// Vue.use(VueClipboard);

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        apiUrl: "http://sms-backend.test/api/canteen",
        backendUrl: "http://sms-backend.test",
        socketUrl: "socket.iskola.app",

        // apiUrl: "http://backend.shifters.tech/api",

        // apiUrl: "https:sms-new.test/api",

        // mahmoud kamal local link
        //    apiUrl: "http://localhost/sms/api",

        // apiUrl: "http://localhost/sms/api",
        sidebarMin: false,
        sidebarDisplay: false,
        vacationsDays: [],
    },
    getters: {
        getApiUrl(state) {
            return state.apiUrl;
        },
        getBackEndUrl(state) {
            return state.backendUrl;
        },
        getSideBarMin(state) {
            return state.sidebarMin;
        },
        getSidebarDisplay(state) {
            return state.sidebarDisplay;
        },
        getVacationsDays(state) {
            return state.vacationsDays;
        },
        getSocketUrl(state) {
            return state.socketUrl;
        },
    },
    mutations: {
        setSideBarMin(state) {
            state.sidebarMin = !state.sidebarMin;
        },
        setSidebarDisplay(state) {
            state.sidebarDisplay = !state.sidebarDisplay;
        },
        setVacationDays(state) {
            // console.log("here");
            let today = new Date();
            let date =
                today.getDate() +
                "/" +
                (today.getMonth() + 1) +
                "/" +
                today.getFullYear();

            axios
                .post(
                    state.apiUrl + "/school/checkVacationDate",
                    {
                        date: date,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.token,
                        },
                    }
                )
                .then((response) => {
                    if (response.data.status.error == false) {
                        state.vacationsDays = response.data.data;
                    }
                });
        },
    },
    actions: {},
    modules: {},
});
